module.exports = __webpack_public_path__ + "img/saltbox.ea590ad5.jpg";